<template>
  <div class="investment_warp">
    <SearchHunt
      :filterData="filterData"
      @handle_seach="handle_seach"
      ref="SearchHunt"
    />
    <a-table
      class="antd-table"
      bordered
      :columns="relevanceBatch_grid.field"
      :data-source="relevanceBatch_grid.row"
      rowKey="id"
      size="small"
      :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
      :pagination="false"
      :loading="tableLoading"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text, record, index">
        {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
      </span>
      <!-- 反馈类型 -->
      <span slot="backType" slot-scope="text, record">
        {{ text | DictionaryFilter('FEED_TYPE') }}
      </span>
      <!-- 操作 -->
      <span slot="operation" slot-scope="text, record">
        <a @click="detaillsFn(record)">详情</a>
      </span>
    </a-table>

    <!-- 底部 -->
    <div class="table_bottom">

      <!-- 分页 -->
      <div>
        <a-pagination
          class="table_pagination"
          show-size-changer
          :default-current="1"
          v-model="pageParam.pageNum"
          :show-total="(total) => `共 ${total} 条`"
          :page-size-options="pageSizeOptions"
          size="small"
          :total="total"
          @showSizeChange="onShowSizeChange"
          @change="paginationChange"
          :page-size.sync="pageParam.pageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryFeedBack,
  detailFeedBack
} from "@/api/api.js";
import SearchHunt from "./components/search-hunt/search-hunt.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "",
  components: {
    SearchHunt,
  },
  data() {
    return {
      //搜索栏
      filterData: [
        {
          name: "custName",
          type: "input",
          value: undefined,
          label: "请输入客户姓名",
          placeholder:"客户姓名：",
        },
        {
          name: "backType",
          type: "select",
          value: undefined,
          label: "请选择反馈类型",
          options: [],
          placeholder:"反馈类型：",
          
        },
      ],
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 45,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "客户姓名",
            align: "center",
            width: 200,
            dataIndex: "custName",
            ellipsis: true,
          },
          {
            title: "反馈类型",
            align: "center",
            width: 120,
            dataIndex: "backType",
            ellipsis: true,
            scopedSlots: {
              customRender: "backType",
            },
          },
          {
            title: "反馈信息",
            colSpan: 1,
            width: 180,
            dataIndex: "backInfo",
            align: "center",
            ellipsis: true,
          },
          {
            title: "联系方式",
            colSpan: 1,
            align: "center",
            width: 80,
            ellipsis: true,
            dataIndex: "phoneNo",
            
          },
          {
            title: "录入时间",
            colSpan: 1,
            align: "center",
            width: 140,
            ellipsis: true,
            dataIndex: "createTime",
          },
          {
            title: "操作",
            colSpan: 1,
            align: "center",
            width: 70,
            ellipsis: true,
            dataIndex: "operation",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      paramsObj: {
        custName: null,
        backType: null
      },
      list: [],
      //查询加载
      tableLoading:false,

      
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["FEED_TYPE"]).then((res) => {
      //反馈类型
      this.filterData[1].options = DictionaryService.getOptions("FEED_TYPE");
      //查询
      this.queryList();
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      queryFeedBack({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      })
      .then((res) => {
        if (res.content.rows && res.content.rows.length) {
          this.relevanceBatch_grid.row = res.content.rows;
          this.total = res.content.page.totalRows;
        } else {
          this.relevanceBatch_grid.row = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }, (err) => {
        this.tableLoading = false;
      });
    },
    //详情
    detaillsFn(data) {
      this.$router.push({ path: '/home/customer-management/feed-back/pages/details', query: { name: data.custName, id:data.id} })
    },

  },
};
</script>

<style scoped lang="less">
.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{

  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }
}
</style>